import React, { useEffect, useMemo, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const ProductsByCategory = () => {
  const { categoryId } = useParams();
  const [products, setProducts] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProductsAndCategory = async () => {
      setLoading(true);

      try {
        const [prodRes, catRes] = await Promise.all([
          axios.get(
            "https://api.vyapakprint.com/api/businessProducts/getAllBusinessProducts",
          ),
          axios.get("https://api.vyapakprint.com/api/category-options"),
        ]);

        const allProducts = Array.isArray(prodRes.data) ? prodRes.data : [];
        const filteredProducts = allProducts.filter(
          (p) => p.category?._id === categoryId,
        );
        setProducts(filteredProducts);

        const categoryOptions = catRes.data?.options || catRes.data || [];
        const foundCategory = categoryOptions.find((c) => c._id === categoryId);
        setCategoryName(foundCategory?.name || "Category");
      } catch (err) {
        console.error("Failed to fetch category/products:", err);
        setProducts([]);
        setCategoryName("Category");
      } finally {
        setLoading(false);
      }
    };

    fetchProductsAndCategory();
  }, [categoryId]);

  const sortedProducts = useMemo(() => {
    return [...products].sort((a, b) =>
      (a?.name || "").localeCompare(b?.name || "", undefined, {
        sensitivity: "base",
      }),
    );
  }, [products]);

  if (loading) {
    return <p className="text-center py-10">Loading products…</p>;
  }

  return (
    <div className="container mx-auto px-6 py-8">
      <h2 className="text-2xl font-semibold mb-6 text-center">
        Products in "{categoryName}"
      </h2>

      {sortedProducts.length === 0 ? (
        <p className="text-center text-gray-500">No products found.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {sortedProducts.map((product) => (
            <Link
              key={product._id}
              to={`/create-order/${product._id}`}
              className="bg-white p-4 rounded-lg shadow hover:shadow-md transition-all duration-300"
            >
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-40 object-cover rounded-md mb-3"
              />
              <h3 className="font-semibold text-lg">{product.name}</h3>
              <p className="text-sm text-gray-600 mt-1">
                Dispatch Time: {product.shippingTime}
              </p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductsByCategory;
